/**
 * "This field saves to Open Dental's Wireless Phone. Add the Is Phone Number rule."
 *
 * WHY A HINT AND NOT AN AUTO-ADD
 * A control mapped to an Open Dental phone or SSN column is the one place where we KNOW
 * what shape the value has to be — Open Dental is going to store whatever the patient
 * typed. But silently adding a rule to somebody's form changes what their patients are
 * blocked on, without them ever asking for it. So the builder offers it in one click and
 * the office decides. (Existing forms are swept separately by the teamio-admin script,
 * which is dry-run by default for the same reason.)
 *
 * ⛔ IMPORT-FREE ON PURPOSE — cypress/node-tests/forms-format-rules.test.js loads and
 * executes THIS EXACT FILE rather than mirroring it. The two labels below are therefore
 * literals; that test also asserts they still match VALIDATION_RULES.
 */

/** Open Dental column -> the format rule that column's values must satisfy. */
const OD_COLUMN_FORMAT_RULES = {
    HmPhone: { ruleType: 'isPhone', label: 'Is Phone Number', odFieldLabel: 'Home Phone' },
    WkPhone: { ruleType: 'isPhone', label: 'Is Phone Number', odFieldLabel: 'Work Phone' },
    WirelessPhone: { ruleType: 'isPhone', label: 'Is Phone Number', odFieldLabel: 'Wireless Phone' },
    SSN: { ruleType: 'isSSN', label: 'Is Social Security Number', odFieldLabel: 'Social Security Number' },
}

/**
 * Which format rule should this control be offered, if any?
 *
 * @param {Object} control the control being configured (carries teamioODColumn, validations)
 * @param {String[]|null} allowedRuleKeys CONTROLS[type].allowedValidationRules, or null for "all"
 * @returns {{ruleType: string, label: string, odFieldLabel: string}|null}
 */
export function getSuggestedFormatRule(control, allowedRuleKeys) {
    if (!control || typeof control !== 'object') {
        return null
    }

    const suggestion = OD_COLUMN_FORMAT_RULES[control.teamioODColumn]
    if (!suggestion) {
        return null
    }

    // An allowlisted control (file uploads: required/min/max) can never run this rule —
    // offering it would push a rule the engine throws on.
    if (Array.isArray(allowedRuleKeys) && !allowedRuleKeys.includes(suggestion.ruleType)) {
        return null
    }

    // Already has it. Case-insensitive because the engine matches case-insensitively, so
    // a hand-edited "isphone" is a real, working rule.
    const wanted = suggestion.ruleType.toLowerCase()
    const existing = Array.isArray(control.validations) ? control.validations : []
    const alreadyHasIt = existing.some(rule =>
        rule && typeof rule.ruleType === 'string' && rule.ruleType.toLowerCase() === wanted
    )
    if (alreadyHasIt) {
        return null
    }

    return { ruleType: suggestion.ruleType, label: suggestion.label, odFieldLabel: suggestion.odFieldLabel }
}

export { OD_COLUMN_FORMAT_RULES }
